
import { useState } from "react";
import BoxColor from "./boxColor"

const BoxColorService = (props: any) => {

  let colorId = props.colorId ?? "";

  let colors = [
    "#DD0707",
    "#E61E61",
    "#9D1CB2",
    "#683AB7",
    "#3449BA",
    "#1794F8",
    "#01B5A5",
    "#4CB051",
    "#8BCA41",
    "#D3E331",
    "#FFEC3C",
    "#FF9802",
    "#FF5520",
    "#704B3E",
    "#8A8E90",
    "#000000"
  ]

  const changeColor = (color: any) => {
    props.changeColor(color);
  }
  return (
    <>
      {colors.map((color: any, index: any) => (
        <div key={index} className="d-inline">
          <BoxColor color={color} handelClick={changeColor} active={colorId === color} />
        </div>
      )
      )}
    </>
  )
}

export default BoxColorService